var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2361 370.6",
    style: {
      enableBackground: "new 0 0 2361 370.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#58AB71;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#CD312F;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M333.1,108.9H127c-29.2,0-30.7,64.3,0,64.3h140.3c45.3,0,80.4,40.9,80.4,90.6c0,43.8-20.5,100.8-80.4,100.8 H52.5v-67.2h214.8c33.6,0,32.2-62.8,0-62.8H116.8c-36.5,0-76-42.4-76-93.5c0-38,26.3-96.4,87.7-96.4H333L333.1,108.9L333.1,108.9 L333.1,108.9z M369.6,242.7c0,83.3,80.4,126.2,157.8,126.2c77.5,0,134.4-59,134.4-126.2c0,0,1.5-145.5,1.5-198.1h-70.1V235 c0,53.4-36.5,61.7-65.7,61.7c-27.8,0-71.6-6.6-71.6-61.7V44.6h-86.2L369.6,242.7L369.6,242.7L369.6,242.7z M917.5,233.1 c48.2,0,73.1-40.9,73.1-92.1c0-52.6-35.1-96.4-86.2-96.4H696.9V369h81.8V233.1h57L902.9,369h92L917.5,233.1z M891.2,177.6H781.6 v-65.7h109.6c14.6,0,35.1,5.8,35.1,32.1C926.3,171.8,905.8,177.6,891.2,177.6z M1037.3,44.6V369h248.4v-68.7h-178.2V111.9h178.2 V44.6H1037.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1114.8,206.8l166.6-59.9v109.6L1114.8,206.8L1114.8,206.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1589.6,111.9V44.6h-116.9c-73.1,0-150.5,42.4-150.5,157.8c0,137.3,100.8,166.6,152,166.6h115.4v-73h-121.3 c-38,0-82.7-40.9-82.7-93.5c0-57,34.5-90.6,75.4-90.6L1589.6,111.9L1589.6,111.9z M1952,369h76V111.9h71.6V369h71.6V111.9 c30.7,0,74.5-11.7,74.5,27.8V369h74.5V141.1c0-46.7-26.3-96.4-112.5-96.4H1952L1952,369L1952,369L1952,369z M1759.2,38.8 c-86.4,0-156.4,74.3-156.4,165.9c0,91.6,70,165.9,156.4,165.9c86.3,0,156.4-74.3,156.4-165.9C1915.5,113.1,1845.5,38.8,1759.2,38.8 z M1759.2,316c-52.1,0-94.4-50-94.4-111.7c0-61.7,42.3-111.7,94.4-111.7c52.1,0,94.3,50,94.3,111.7 C1853.5,266,1811.2,316,1759.2,316z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg06);
export default __webpack_public_path__ + "static/media/06.88a62490c4c4b96933c943f1d5879d2a.svg";
export { ForwardRef as ReactComponent };